import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";

interface RolesContextProps {
  roles: string[];
  groups: string[];
  setRoles: (r: string[]) => void;
  setGroups: (g: string[]) => void;
}

const RolesContext = createContext<RolesContextProps>({
  roles: [],
  groups: [],
  setRoles: () => {},
  setGroups: () => {},
});

export const useRoles = () => useContext(RolesContext);

export const RolesProvider: React.FC<{
  children: ReactNode;
  onReady?: (setRoles: (r: string[]) => void, setGroups: (g: string[]) => void) => void;
}> = ({ children, onReady }) => {
  const [roles, setRoles] = useState<string[]>([]);
  const [groups, setGroups] = useState<string[]>([]);

  useEffect(() => {
    if (onReady) {
      onReady(setRoles, setGroups); 
    }
  }, [onReady]);

  return (
    <RolesContext.Provider value={{ roles, groups, setRoles, setGroups }}>
      {children}
    </RolesContext.Provider>
  );
};
